/* Block styles */
import "./block.scss";

/**
 * The core image block will not be using the default styles and will instead
 * be using custom styles.
 */
wp.domReady(() => {
    // Unregister the default styles
    wp.blocks.unregisterBlockStyle("core/image", ["rounded"]);

    // Register new styles
    wp.blocks.registerBlockStyle("core/image", {
        name: "no-border",
        label: "No Border",
    });
    wp.blocks.registerBlockStyle("core/image", {
        name: "top-left",
        label: "Top Left",
    });
    wp.blocks.registerBlockStyle("core/image", {
        name: "top-right",
        label: "Top Right",
    });
    wp.blocks.registerBlockStyle("core/image", {
        name: "bottom-left",
        label: "Bottom Left",
    });
    wp.blocks.registerBlockStyle("core/image", {
        name: "bottom-right",
        label: "Bottom Right",
    });

    // Start Front-End Javascript
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("show");
            } else {
                // entry.target.classList.remove("show");
            }
        });
    });

    const hiddenElements = document.querySelectorAll(".wp-block-image");
    hiddenElements.forEach((element) => {
        observer.observe(element);
    });
});
